<div>
  <button
    matSuffix
    mat-icon-button
    color="primary"
    (click)="onOpenLocatorImportDataDialog()"
    aria-label="import library data"
    i18n-aria-label="@@importLibraryDataAriaLabel"
    matTooltip="Import library data"
    i18n-matTooltip="@@importLibraryDataTooltip"
    [matTooltipShowDelay]="1000"
    [matTooltipHideDelay]="1000"
    [disabled]="isCatchmentReportingReadonlySystem$ | async"
  >
    <mat-icon>save_alt</mat-icon>
  </button>
</div>
